import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@domainstack/ui/spinner";
export function HostingMapSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative h-[280px] w-full rounded-xl border bg-muted/20 backdrop-blur-lg"><div className="absolute inset-0 flex h-full w-full items-center justify-center"><div className="flex items-center gap-1.5 text-[13px] text-muted-foreground"><Spinner className="size-4" />Loading map…</div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}